import { CurrencyCodeEnum } from "types";
import { useOperator } from "./useOperator";

function useOperatorCurrency(): (money: number) => string {
  const operator = useOperator();
  const currencyCode = operator?.settings?.currencyCode || CurrencyCodeEnum.Usd;

  const currency = (money: number) => {
    if (money === undefined) return "-";
    // To add currency support, add a new currency code to local entry here.
    const localMap = {
      [CurrencyCodeEnum.Usd]: "en-US",
      [CurrencyCodeEnum.Cad]: "en-CA",
      [CurrencyCodeEnum.Uah]: "uk-UA", // Ukraine
      [CurrencyCodeEnum.Eur]: "nl-NL", // Netherlands
      [CurrencyCodeEnum.Aud]: "en-AU", // Australia
    };

    return new Intl.NumberFormat(localMap[currencyCode], {
      style: "currency",
      currency: currencyCode.toUpperCase(),
    }).format(money);
  };
  return currency;
}

export default useOperatorCurrency;
